(() => {
  if (window.ShopHeartsWishlist) return;
  const config = document.querySelector('[data-sh-wishlist-runtime]');
  if (!config) return;
  const text = config.dataset, key = 'shophearts.wishlist', version = 1, limit = 100;
  const page = document.querySelector('[data-sh-wishlist-page]');
  const list = page?.querySelector('[data-sh-wishlist-list]');
  const root = new URL(text.rootUrl || '/', location.origin);
  const productId = value => /^\d+$/.test(String(value)) ? 'gid://shopify/Product/' + value : /^gid:\/\/shopify\/Product\/\d+$/.test(String(value)) ? String(value) : null;
  let items = [], problem = '', generation = 0, scheduled = false, rendered = null;
  const snapshot = () => ({schema_version:version,items:items.map(item => ({...item}))});
  const announce = message => { config.querySelector('[data-sh-wishlist-status]').textContent = message; };
  const titleLabel = (label, title) => label.replace('[product]', title);
  function read() {
    try {
      const raw = localStorage.getItem(key);
      const value = raw ? JSON.parse(raw) : {schema_version:version,items:[]};
      if (value.schema_version !== version || !Array.isArray(value.items)) throw new TypeError();
      const unique = new Map();
      for (const item of value.items) {
        if (!item || typeof item !== 'object') continue;
        const id = productId(item.product_id);
        if (!id || typeof item.handle !== 'string' || !/^[a-z0-9][a-z0-9_-]{0,254}$/.test(item.handle)) continue;
        if (!unique.has(id)) unique.set(id, {product_id:id,handle:item.handle,title:String(item.title || item.handle).slice(0,300),saved_at:typeof item.saved_at === 'string' ? item.saved_at : null,variant_id:null});
        if (unique.size === limit) break;
      }
      items = [...unique.values()];
      problem = '';
      return true;
    } catch (error) {
      problem = error instanceof SyntaxError || error instanceof TypeError ? text.unsupported : text.blocked;
      return false;
    }
  }
  function sync() {
    document.querySelectorAll('.grid-product[data-product-id][data-product-handle]').forEach(card => {
      const content = card.querySelector('.grid-product__content');
      if (!content || content.querySelector('[data-sh-wishlist-toggle]') || !productId(card.dataset.productId)) return;
      const template = document.querySelector('[data-sh-wishlist-control]');
      if (!template) return;
      const button = template.content.firstElementChild.cloneNode(true);
      button.dataset.productId = card.dataset.productId;
      button.dataset.handle = card.dataset.productHandle;
      button.dataset.title = card.querySelector('.grid-product__title')?.textContent || card.dataset.productHandle;
      content.prepend(button);
    });
    const ids = new Set(items.map(item => item.product_id));
    document.querySelectorAll('[data-sh-wishlist-toggle]').forEach(button => {
      const saved = ids.has(productId(button.dataset.productId));
      button.hidden = false;
      button.disabled = Boolean(problem);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', problem || titleLabel(saved ? text.removeProduct : text.saveProduct, button.dataset.title || ''));
      if (problem) button.title = problem; else button.removeAttribute('title');
      const label = button.querySelector('[data-sh-wishlist-label]');
      if (label) label.textContent = saved ? text.saved : text.save;
    });
    document.querySelectorAll('[data-sh-wishlist-count]').forEach(count => { count.textContent = String(items.length); count.hidden = items.length === 0; });
    document.querySelectorAll('[data-sh-wishlist-link]').forEach(link => link.setAttribute('aria-label', text.count.replace('[count]', items.length)));
    if (page) {
      const warning = page.querySelector('[data-sh-wishlist-warning]');
      warning.hidden = !problem;
      warning.textContent = problem;
    }
  }
  function commit(next, message) {
    try {
      localStorage.setItem(key, JSON.stringify({schema_version:version,updated_at:new Date().toISOString(),items:next}));
      items = next;
      problem = '';
    } catch {
      problem = text.blocked;
      sync();
      announce(problem);
      return false;
    }
    sync();
    render();
    announce(message);
    document.dispatchEvent(new CustomEvent('sh:wishlist:change', {detail:snapshot()}));
    return true;
  }
  const el = (tag, className, value) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  };
  const productUrl = handle => new URL('products/' + encodeURIComponent(handle), root);
  async function hydrate(item, card, current) {
    const status = card.querySelector('[data-status]'), details = card.querySelector('[data-details]');
    card.querySelector('.sh-wishlist-image').replaceChildren();
    let missing = false;
    try {
      const response = await fetch(productUrl(item.handle).href + '.js', {credentials:'same-origin',signal:AbortSignal.timeout(10000)});
      missing = response.status === 404 || response.status === 410;
      if (!response.ok) throw new Error();
      const product = await response.json();
      missing = productId(product.id) !== item.product_id;
      if (missing) throw new Error();
      if (current !== generation || !card.isConnected) return;
      card.querySelector('h2').textContent = String(product.title || item.title);
      status.textContent = product.available ? '' : text.soldOut;
      const picture = product.featured_image;
      if (typeof picture === 'string' && picture) {
        const src = new URL(picture, location.origin);
        if (src.protocol === 'https:' && (src.origin === location.origin || src.hostname === 'cdn.shopify.com')) {
          const image = el('img'); image.src = src.href; image.alt = ''; image.loading = 'lazy'; image.width = 360; image.height = 480;
          card.querySelector('.sh-wishlist-image').append(image);
        }
      }
      if (Number.isFinite(product.price)) {
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:text.currency,currencyDisplay:'code'}).format(product.price / 100);
        const price = el('p', '', product.price_varies ? text.fromPrice.replace('[price]', formatted) : formatted);
        details.append(price);
      }
      const link = el('a', 'btn', product.available ? text.choose : text.view); link.href = productUrl(item.handle).href; details.append(link);
    } catch {
      if (current !== generation || !card.isConnected) return;
      status.textContent = missing ? text.unavailable : text.loadError;
      if (!missing) {
        const link = el('a', 'btn', text.view); link.href = productUrl(item.handle).href; details.append(link);
        const retry = el('button', 'sh-wishlist-remove', text.retry); retry.type = 'button';
        retry.addEventListener('click', () => { details.replaceChildren(); status.textContent = text.loading; hydrate(item, card, current); });
        details.append(retry);
      }
    }
  }
  function render() {
    if (!page) return;
    const signature = JSON.stringify({items,problem});
    if (signature === rendered) return;
    rendered = signature;
    const current = ++generation;
    page.querySelector('[data-sh-wishlist-loading]').hidden = true;
    page.querySelector('[data-sh-wishlist-empty]').hidden = items.length > 0 || Boolean(problem);
    list.replaceChildren();
    const jobs = items.map(item => {
      const card = el('li', 'sh-wishlist-item');
      const status = el('p', '', text.loading); status.dataset.status = '';
      const details = el('div'); details.dataset.details = '';
      const remove = el('button', 'sh-wishlist-remove', text.remove); remove.type = 'button'; remove.dataset.shWishlistRemove = item.product_id; remove.disabled = Boolean(problem); remove.setAttribute('aria-label', titleLabel(text.removeProduct, item.title));
      card.append(el('div','sh-wishlist-image'),el('h2','',item.title),status,details,remove);
      list.append(card);
      return () => hydrate(item, card, current);
    });
    const worker = async () => { while (jobs.length && current === generation) await jobs.shift()(); };
    const workers = Math.min(4,jobs.length);
    for (let i=0;i<workers;i++) worker();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sh-wishlist-toggle], [data-sh-wishlist-remove]');
    if (!button || button.disabled) return;
    event.preventDefault();
    if (!read()) { sync(); announce(problem); return; }
    const removing = button.hasAttribute('data-sh-wishlist-remove');
    const id = productId(removing ? button.dataset.shWishlistRemove : button.dataset.productId);
    if (!id) return;
    const saved = items.some(item => item.product_id === id);
    const index = removing ? [...list.querySelectorAll('[data-sh-wishlist-remove]')].indexOf(button) : -1;
    let next;
    if (saved || removing) next = items.filter(item => item.product_id !== id);
    else {
      if (items.length >= limit) { announce(text.limit); return; }
      const handle = button.dataset.handle;
      if (!handle || !/^[a-z0-9][a-z0-9_-]{0,254}$/.test(handle)) return;
      next = [...items,{product_id:id,handle,title:(button.dataset.title || handle).slice(0,300),saved_at:new Date().toISOString(),variant_id:null}];
    }
    if (commit(next, saved || removing ? text.removed : text.added) && removing) {
      const controls = list.querySelectorAll('[data-sh-wishlist-remove]');
      (controls[Math.min(index, controls.length-1)] || page.querySelector('h1')).focus();
    }
  });
  function refresh() { read(); sync(); render(); }
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) refresh(); });
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-sh-wishlist-toggle],[data-sh-wishlist-link],.grid-product[data-product-id]') || node.querySelector('[data-sh-wishlist-toggle],[data-sh-wishlist-link],.grid-product[data-product-id]')))) || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  }).observe(document.body, {childList:true,subtree:true});
  window.ShopHeartsWishlist = Object.freeze({key,version,read:() => read() ? snapshot() : null});
  refresh();
})();
